module.exports = __webpack_public_path__ + "static/img/strona_006.1189188f.jpg";